module.exports = __webpack_public_path__ + "img/img-spadegaming-d.0bc47df0.png";